<template>
	<div
		class="c-library-archive"
		:class="{ 'c-library-archive--load-more': showLoadMore, 'c-library-archive--filter-active': showFilter }"
	>
		<div class="c-library-archive__filter-wrapper">
			<div class="c-library-archive__filter-wrapper-bg" @click="showFilter = false"></div>
			<fieldset class="c-library-archive__filter">
				<legend class="screen-reader-text">Filters</legend>
				<fieldset class="c-radio-switch">
					<legend class="screen-reader-text">Sort by</legend>
					<div class="c-radio-switch__wrapper">
						<legend class="c-radio-switch__legend" aria-hidden="true">Sort by:</legend>

						<div class="c-radio-switch__radios">
							<div class="c-radio-switch__radio">
								<input
									class="c-radio-switch__input"
									type="radio"
									id="release_date"
									value="releaseDate"
									v-model="orderby"
								/>
								<label class="c-radio-switch__label" for="release_date">
									<span>Most recent</span>
								</label>
							</div>

							<div class="c-radio-switch__radio">
								<input
									class="c-radio-switch__input"
									type="radio"
									id="word_count"
									value="wordCount"
									v-model="orderby"
								/>
								<label class="c-radio-switch__label" for="word_count">
									<span>Word count</span>
								</label>
							</div>
						</div>
					</div>
				</fieldset>
				<button
					type="button"
					class="c-button c-library-archive__filter-close"
					@click="showFilter = false"
					aria-label="Close filters"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
					>
						<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
					</svg>
				</button>
			</fieldset>
		</div>
		<div class="c-library-archive__filter-toggle-wrapper">
			<button
				type="button"
				class="c-button c-button--floating c-library-archive__filter-toggle"
				@click="showFilter = !showFilter"
			>
				<span>Filter</span>
			</button>
		</div>
		<div class="c-library-archive__table-wrapper">
			<table class="c-library-table">
				<caption class="c-library-table__caption">
					All Stories
				</caption>
				<thead>
					<tr class="c-library-table__row">
						<th class="c-library-table__header">Authors</th>
						<th class="c-library-table__header">Title</th>
						<th class="c-library-table__header">Word Count</th>
						<th class="c-library-table__header">Release Date</th>
					</tr>
				</thead>
				<tbody>
					<tr class="c-library-table__row" v-for="story in stories" :key="story.id">
						<td class="c-library-table__cell c-library-table__cell--authors">
							<a :href="story.url" :aria-label="story.title" tabindex="-1">
								<div class="c-author-indicators" v-if="story.writers">
									<div
										class="c-author-indicator"
										v-for="writer in story.writers"
										:style="{ '--color': `${writer.color}` }"
									></div>
								</div>
							</a>
						</td>
						<td class="c-library-table__cell c-library-table__cell--title">
							<a class="c-library-table__title" :href="story.url" v-html="story.title"></a>
						</td>
						<td class="c-library-table__cell">
							<a :href="story.url" tabindex="-1">
								{{ story.wordCount }}
							</a>
						</td>
						<td class="c-library-table__cell">
							<a :href="story.url" tabindex="-1">
								{{ story.releaseDate }}
							</a>
						</td>
					</tr>
				</tbody>
			</table>
			<button class="c-button c-library-archive__load-more" v-if="showLoadMore" @click="currentPage++">
				<span>Load More</span>
			</button>
		</div>
	</div>
</template>

<script>
import { disablePageScroll, enablePageScroll } from 'scroll-lock';

export default {
	name: 'Stories',
	props: {
		data: Array,
	},
	data() {
		return {
			orderby: 'releaseDate',
			perPage: 20,
			currentPage: 1,
			showFilter: false,
		};
	},
	watch: {
		showFilter() {
			this.showFilter ? disablePageScroll() : enablePageScroll();
		},
	},
	computed: {
		showLoadMore() {
			if (this.perPage * this.currentPage < this.data.length) {
				return true;
			}

			return false;
		},
		stories() {
			let result = [];

			if (this.orderby == 'wordCount') {
				result = this.data.sort((a, b) => {
					return parseInt(b.wordCount, 10) - parseInt(a.wordCount, 10);
				});
			}

			if (this.orderby == 'releaseDate') {
				result = this.data.sort((a, b) => {
					return new Date(b.releaseDate) - new Date(a.releaseDate);
				});
			}

			return result.slice(0, this.perPage * this.currentPage);
		},
	},
};
</script>

<style lang="scss" scoped></style>
